import i18next from "i18next";

function generateTitle(fixedTitle, h1, h1WithoutFilters, currentPage) {
  if (fixedTitle) {
    if (currentPage <= 1) {
      return fixedTitle;
    }
    const title = fixedTitle.split(" - ");
    title[0] = `${title[0]}: ${i18next.t("Page")} - ${currentPage}`;
    return title.join(" - ");
  }
  if (h1WithoutFilters)
    return `${h1}${
      currentPage > 1 ? `: ${i18next.t("Page")} - ${currentPage}` : ""
    } - купить ${h1WithoutFilters} в Киеве и Украине, цены на ${h1WithoutFilters} в интернет-магазине детской одежды ALFAKID`;
  if (h1)
    return `${h1}${
      currentPage > 1 ? `: ${i18next.t("Page")} - ${currentPage}` : ""
    } - купить ${h1} в Киеве и Украине, цены на ${h1} в интернет-магазине детской одежды ALFAKID`;
}

export default generateTitle;
